<script>
	import { imageLightbox, imageLightboxCaptions } from "src/store/store";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte";

	export let detailData;

	let {
		job: { tasks },
	} = detailData;

	let modalOpen = false;
	let imgIndex = 0;

	function handleOpenImage(i, imgs) {
		function mapPhotos(items, mapType, mapTo) {
			return items
				.filter((item) => item && item.url && item.type === mapType)
				.map((item) => item[mapTo]);
		}
		const allImageUrls = mapPhotos(imgs, "Photo", "url");
		const allCaptions = mapPhotos(imgs, "Photo", "caption");
		imageLightbox.set(allImageUrls);
		imageLightboxCaptions.set(allCaptions);
		imgIndex = Number(i);
		modalOpen = true;
	}
</script>

{#if modalOpen}
	<Lightbox
		on:click={() => (modalOpen = false)}
		imageShowingIndex={imgIndex}
	/>
{/if}
<div>
	{#each tasks as item}
		{#if item?.media?.length !== 0}
			<div>
				<h5>
					{item?.presetTask.code}
				</h5>
			</div>
			<div class="d-flex flex-wrap">
				{#each item.media.filter((img) => img.type === "Photo") as img, i}
					<img
						class="inspect-img mb-2"
						src={img.url}
						alt="job-inspection"
						on:click={() => handleOpenImage(i, item.media)}
						on:keydown={() => {}}
					/>
				{/each}
				{#each item.media.filter((img) => img.type === "Video") as img}
					<div
						class="inspect-img d-flex flex-column justify-content-center align-items-center mb-2"
						style="background: #f0f0f0;"
					>
						<a
							href={img.url}
							target="_blank"
							rel="noopener noreferrer">Watch Video</a
						>
					</div>
				{/each}
			</div>
		{/if}
	{/each}
</div>

<style>
</style>
